/**
 * Shared icon-size scale for Material Symbols, consumed by BOTH the web `<MaterialIcon>`
 * (`client/src/ui/MaterialIcon.tsx`) and the React Native `<Icon>` (`mobile/src/ui/icon.tsx`).
 *
 * Lives in `@elara/client-core` (alongside the `IconName` union, ELARA-700) so the two platforms
 * size icons from ONE source — a `size="sm"` renders the same 20pt box on web and native, and a
 * model field typed against this scale drops straight into either component. The values are points
 * on native / pixels on web (1:1 at the base density).
 */

/** Preset icon sizes matching common UI patterns. `auto` (0) means "inherit from surrounding text". */
export const IconSizes = { auto: 0, xxs: 14, xs: 16, sm: 20, md: 24, lg: 32, xl: 40, '2xl': 48 } as const;

/** A preset size key, or a raw point/pixel value for one-off sizing. */
export type IconSize = keyof typeof IconSizes | number;
